import { Row, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  margin: 2rem 0;
`;

interface PageTitleProps {
  title?: string;
  actions?: any;
  onBack?: () => void;
}

export const PageTitle: React.FunctionComponent<PageTitleProps> = (props) => (
  <Container>
    <Row justify={'space-between'}>
      <Space>
        { props.onBack && <ArrowLeftOutlined onClick={props.onBack} style={{
          marginRight: '.8rem',
          marginLeft: '.2rem',
          fontFamily: '"Quicksand", "sans-serif"',
          fontSize: '1.8rem'}} /> }
        <h1>{props.title}</h1>
      </Space>

      {props.actions}
    </Row>
  </Container>
);
